(function(){
    angular
        .module('app')
        .directive('ngSignature', signature);

        signature.$inject = ['$timeout'];
        function signature($timeout){
            return {
              require: 'ngModel',
              scope:{
                ngModel:"=",
                options:"=",
                clear:"=",
                signature:"="
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                  var options = {};
                  if(scope.options){
                    options = scope.options;
                  }
                  //console.log(scope.options);
                  var valorrel = "";
                  var value = $attrs.value;
                  var $element = $(element);

                  var canvas = document.createElement('canvas');

                  console.log($element.width());
                  console.log($element.height());
                  canvas.id = "SignatureLayer";
                  canvas.width = $element.width();
                  canvas.height = $element.height();
                  /*canvas.style.zIndex = 8;
                  canvas.style.position = "absolute";
                  canvas.style.border = "1px solid";
                  */
                  $element.append(canvas);
                  // Adjust canvas coordinate space taking into account pixel ratio,
                  // to make it look crisp on mobile devices.
                  // This also causes canvas to be cleared.
                  var resizeCanvas = function() {
                      // When zoomed out to less than 100%, for some very strange reason,
                      // some browsers report devicePixelRatio as less than 1
                      // and only part of the canvas is cleared then.
                      var w = $element.width();
                      canvas.width = w;
                      canvas.height = $element.height();
                      if(w === 0){
                        $timeout(resizeCanvas,300);
                      }
                  }

                  jQuery(window).on("resize",resizeCanvas);
                  
                  $timeout(resizeCanvas,300);

                  console.log(SignaturePad);
                  if (SignaturePad != undefined) {
                      console.log("Signature create");

                  var signaturePad = new SignaturePad(canvas, {
                    backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
                  });
                  

                  signaturePad.addEventListener("endStroke", () => {
                      if (signaturePad.isEmpty()) {
                        return alert("Please provide a signature first.");
                    
                      }
                      scope.signature = true;

                      console.log(scope.signature);
                      console.log("Signature started");
                      $timeout(function(){
                        ngModel.$setViewValue(signaturePad.toDataURL());
                      });
                      

                  });

                  scope.$watch("clear",function(){
                    
                    if(scope.clear){
                      signaturePad.clear();
                      scope.clear = false;
                      ngModel.$setViewValue('');
                      
                    }
                  })                  
                  }


                    //scope.$watch('ngModel', cambiando, true);

                });
            }
          }
      }
})();